var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, forwardRef, isValidElement, memo, useState, } from "react";
import useResizeObserver from "../../hooks/useResizeObserver";
import { StyledTabList } from "./TabList.style";
import { useTabsContext } from "./TabsContext";
import Select from "../select/Select";
import { isTabElement } from "./Tab";
const RFBasicTabList = (_a, ref) => {
    var { children, shouldRenderSelect } = _a, props = __rest(_a, ["children", "shouldRenderSelect"]);
    return (React.createElement(StyledTabList, Object.assign({ ref: ref, role: shouldRenderSelect ? "none" : "tablist", shouldRenderSelect: shouldRenderSelect }, props),
        React.createElement("div", { role: "none" }, children)));
};
const BasicTabList = memo(forwardRef(RFBasicTabList));
const getEnabledTabs = (children) => {
    return Children.toArray(children).filter((child) => isValidElement(child) && isTabElement(child) && !child.props.disabled);
};
const tabToOption = ({ props: { id, label } }) => ({
    value: id,
    label: label || id,
});
const ResponsiveTabSelect = memo(function ResponsiveTabSelect(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { selectedTab, setSelectedTab } = useTabsContext();
    const tabs = getEnabledTabs(children);
    const options = tabs.map(tabToOption);
    return (React.createElement(Select, Object.assign({}, props, { size: "large", options: options, currentValue: selectedTab, onChange: (option) => {
            var _a, _b;
            if (!option) {
                return;
            }
            setSelectedTab(option.value);
            // if the tab has an onSelected callback, call it
            const tabWithOnSelectedCallback = tabs.find((tab) => tab.props.id === option.value && Boolean(tab.props.onSelected));
            (_b = tabWithOnSelectedCallback === null || tabWithOnSelectedCallback === void 0 ? void 0 : (_a = tabWithOnSelectedCallback.props).onSelected) === null || _b === void 0 ? void 0 : _b.call(_a);
        } })));
});
const ResponsiveTabList = (props) => {
    const [ref, setRef] = useState(null);
    useResizeObserver(ref);
    const shouldRenderSelect = Boolean(ref && ref.scrollWidth > ref.clientWidth);
    return (React.createElement(React.Fragment, null,
        shouldRenderSelect && React.createElement(ResponsiveTabSelect, Object.assign({}, props)),
        React.createElement(BasicTabList, Object.assign({ ref: setRef }, props, { responsive: true, shouldRenderSelect: shouldRenderSelect }))));
};
const TabList = (props) => {
    const { responsive } = useTabsContext();
    const Component = responsive ? ResponsiveTabList : BasicTabList;
    return React.createElement(Component, Object.assign({ responsive: responsive }, props));
};
export default TabList;
//# sourceMappingURL=TabList.js.map